namespace RioERP.Enquiry {
    export interface AssignAgentRequest extends Serenity.ServiceRequest {
        HandledBy?: number;
        ids?: string;
    }
}
